export enum OpenAIRole {
  system = 'system',
  assistant = 'assistant',
  user = 'user',
}
  
export interface IAIBody {
  elements: IAIElement[];
  currentJSON?: any;
  language?: string;
  advanced?: boolean;
}
  
export interface IAIElement {
  content: string;
  role: OpenAIRole;
  language?: string;
  isLoading?: boolean;
  isRetry?: boolean;
  isLastUserMessage?: boolean;
  isConfirm?: boolean;
}
  
export interface OAIResult {
  index: number;
  message: {
    role: OpenAIRole;
    content: string;
    json: any;
    refusal: any;
  };
  logprobs: any;
  finish_reason: string;
}
